<template>
<div>
  <v-form>
  <div class="d-flex">
    <v-text-field
      v-model="inputHour"
      :rules="[isHour]"
      variant="outlined"
      density="compact"
      hide-details=""
      :suffix="$t('common.hour')"
      type="number"
    ></v-text-field>
    <p class="ma-2 align-center">:</p>
    <v-text-field
      v-model="inputMinute"
      :rules="[isMinute]"
      variant="outlined"
      density="compact"
      hide-details=""
      :suffix="$t('common.minute')"
      type="number"
    ></v-text-field>
    </div>
  </v-form>
</div>
</template>

<script lang="ts">
import ValidationMixin from '@/mixins/ValidationMixin';
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TimeInput',

  mixins: [ValidationMixin],

  props: {
    hour: {
      type: Number,
      default: 6,
    },
    minute: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    inputHour: {
      get(): number {
        return this.hour;
      },
      set(value: number) {
        this.$emit('hour', value);
      }
    },
    inputMinute: {
      get(): number {
        return this.minute;
      },
      set(value: number) {
        this.$emit('minute', value);
      }
    },
  },
})
</script>